import { useEffect, useRef, useState } from 'react';
import {
  getDraftIdentity, readPersistedFormDraft, writePersistedFormDraft,
  type DraftDiagnostic, type PersistedFormDraft,
} from './activation-persistence';
import type { InvitationFormDiagnostic } from '../use-accept-invitation-logger';

export const useActivationFormDraft = (
  code: string,
  username: string | undefined,
  provider: string | undefined,
  // eslint-disable-next-line no-unused-vars
  logDiagnostic: (diagnostic: InvitationFormDiagnostic) => void
) => {
  const identity = getDraftIdentity(username, provider);
  const [restored] = useState(() => {
    let diagnostic: DraftDiagnostic | undefined;
    const draft = readPersistedFormDraft(code, identity, (result) => { diagnostic = result; });
    return { draft, diagnostic };
  });
  // Presence, including a cleared value, wins over prefill. The page remounts on identity change.
  const editedFields = useRef<PersistedFormDraft>(restored.draft);
  const draftReported = useRef(false);
  useEffect(() => {
    if (restored.diagnostic && !draftReported.current) {
      draftReported.current = true;
      logDiagnostic(restored.diagnostic);
    }
  }, [restored, logDiagnostic]);

  const persistEdit = (patch: PersistedFormDraft) => {
    editedFields.current = { ...editedFields.current, ...patch };
    writePersistedFormDraft(code, editedFields.current, identity);
  };

  return { draft: restored.draft, editedFields, persistEdit };
};
